const h = {
  name: "Calendar18",
  dimensions: { width: 38, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 40" style="enable-background:new 0 0 38 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,17h8v14h-8V17z M23,23h4v-4h-4V23z M23,25v4h4v-4H23z"/>
		<path class="st0" d="M11,17h5v12h3v2h-8v-2h3V19h-3V17z"/>
		<path class="st0" d="M28,2H10V0H8v2H5C2.2,2,0,4.2,0,7v28c0,2.8,2.2,5,5,5h28c2.8,0,5-2.2,5-5V7c0-2.8-2.2-5-5-5h-3V0h-2V2z M8,6
			h2V4h18v2h2V4h3c1.7,0,3,1.3,3,3v1H2V7c0-1.7,1.3-3,3-3h3V6z M2,10h34v25c0,1.7-1.3,3-3,3H5c-1.7,0-3-1.3-3-3V10z"/>
	</g>
</g>
</svg>
  `
};
export {
  h as Calendar18
};
